import { useQuery } from '@tanstack/vue-query';
import { computed, unref, type MaybeRef } from 'vue';

export type NearbyProject = {
  complexId: string;
  slug: string;
  title: string;
  fromAed: number;
  quarter: string;
};

type NearbyProjectsResponse = {
  success: boolean;
  data: NearbyProject[];
};

export const useNearbyProjectsQuery = (
  area: MaybeRef<string | null>,
  excludeId: MaybeRef<string | null>,
) => {
  return useQuery({
    queryKey: [
      'nearby-projects',
      computed(() => unref(area) || ''),
      computed(() => unref(excludeId) || ''),
    ],
    queryFn: () =>
      $fetch<NearbyProjectsResponse>(
        `/api/properties/nearby/${encodeURIComponent(unref(area) as string)}`,
        {
          params: unref(excludeId) ? { excludeId: unref(excludeId) as string } : undefined,
        },
      ).then((r) => r.data),
    enabled: computed(() => !!unref(area)),
    staleTime: 10 * 60 * 1000,
  });
};
